<template>
	<div>
		<!-- 展示区：仅中文名，点击打开选择弹窗 -->
		<div
			class="country-display d-flex align-center flex-wrap ga-1 pa-2 rounded"
			:class="{ 'country-display--empty': !selectedList.length }"
			role="button"
			tabindex="0"
			@click="openDialog"
			@keydown.enter.prevent="openDialog"
		>
			<template v-if="selectedList.length">
				<v-chip
					v-for="code in selectedList"
					:key="code"
					size="small"
					label
					color="primary"
					variant="tonal"
					closable
					@click.stop="removeCode(code)"
					@click:close.stop="removeCode(code)"
				>
					{{ countryLabel(code) }}
				</v-chip>
			</template>
			<span v-else class="text-medium-emphasis text-body-2">
				点击选择国家{{ multiple ? '（可多选）' : '' }}
			</span>
			<v-spacer />
			<v-icon size="small" color="primary">mdi-earth</v-icon>
		</div>

		<v-dialog v-model="dialog" max-width="560" scrollable>
			<v-card>
				<v-card-title class="d-flex align-center">
					选择国家
					<span class="text-caption text-medium-emphasis ml-2">
						{{ multiple ? '可多选' : '单选' }}
					</span>
					<v-spacer />
					<v-btn icon variant="text" size="small" @click="dialog = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-divider />
				<v-card-text class="pt-4">
					<div class="text-caption text-medium-emphasis mb-2">常用 / 已添加</div>
					<div class="d-flex flex-wrap ga-2 mb-4">
						<v-chip
							v-for="c in listCountries"
							:key="c.code"
							label
							:color="isSelected(c.code) ? 'primary' : undefined"
							:variant="isSelected(c.code) ? 'flat' : 'tonal'"
							class="cursor-pointer"
							@click="toggleCode(c.code)"
						>
							{{ c.cname }}
							<v-icon v-if="isSelected(c.code)" end size="small">mdi-check</v-icon>
						</v-chip>
					</div>

					<v-divider class="mb-4" />
					<div class="text-caption text-medium-emphasis mb-2">添加非常用国家</div>
					<v-row dense>
						<v-col cols="5">
							<v-select
								v-model="continent"
								label="大洲"
								item-value="name"
								item-title="cname"
								:items="continents"
								hide-details
								clearable
								density="comfortable"
								@update:model-value="onContinentChange"
							/>
						</v-col>
						<v-col cols="7">
							<v-select
								v-model="pickCountry"
								label="国家"
								item-value="code"
								item-title="cname"
								:items="dropdownCountries"
								hide-details
								clearable
								density="comfortable"
								:disabled="!continent"
								@update:model-value="addFromDropdown"
							/>
						</v-col>
					</v-row>
					<div class="text-caption text-medium-emphasis mt-2">
						从下拉选择后会加入上方列表并自动选中
					</div>
				</v-card-text>
				<v-divider />
				<v-card-actions>
					<v-btn variant="text" @click="clearSelection">清空</v-btn>
					<v-spacer />
					<v-btn color="primary" variant="flat" @click="confirmDialog">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
const DEFAULT_COMMON_CODES = [
	'CN',
	'ET',
	'CO',
	'BR',
	'GT',
	'KE',
	'CR',
	'HN',
	'PE',
	'SV',
	'PA',
	'RW',
	'YE',
	'ID',
	'PG'
]

export default {
	name: 'country-selector',
	props: {
		initCode: { type: [String, Array], default: null },
		modelValue: { type: [String, Array], default: null },
		/** 常用国家 ISO 代码列表 */
		commonCodes: {
			type: Array,
			default: () => [...DEFAULT_COMMON_CODES]
		},
		/** 是否多选 */
		multiple: { type: Boolean, default: false }
	},
	emits: ['selected', 'update:modelValue'],
	data() {
		return {
			dialog: false,
			selectedcode: null,
			/** 内部选中的 ISO 列表 */
			selected: [],
			/** 非常用但已加入列表的 ISO */
			extraCodes: [],
			continent: null,
			pickCountry: null,
			countries: [],
			cur: null,
			continents: [
                {
                    name: 'EU',
                    cname: '\u6b27\u6d32',
                    country: [
                        {
                            cname: '\u65af\u74e6\u5c14\u5df4\u7fa4\u5c9b\u548c\u626c\u9a6c\u5ef6\u5c9b',
                            name: 'Svalbard & Jan Mayen',
                            code: 'SJ'
                        },
                        { cname: '\u4e39\u9ea6', name: 'Denmark', code: 'DK' },
                        {
                            cname: '\u4e4c\u514b\u5170',
                            name: 'Ukraine',
                            code: 'UA'
                        },
                        {
                            cname: '\u4fc4\u7f57\u65af',
                            name: 'Russian Federation',
                            code: 'RU'
                        },
                        {
                            cname: '\u4fdd\u52a0\u5229\u4e9a',
                            name: 'Bulgaria',
                            code: 'BG'
                        },
                        {
                            cname: '\u514b\u7f57\u5730\u4e9a',
                            name: 'Croatia',
                            code: 'HR'
                        },
                        { cname: '\u51b0\u5c9b', name: 'Iceland', code: 'IS' },
                        {
                            cname: '\u5217\u652f\u6566\u58eb\u767b',
                            name: 'Liechtenstein',
                            code: 'LI'
                        },
                        {
                            cname: '\u5308\u7259\u5229',
                            name: 'Hungary',
                            code: 'HU'
                        },
                        {
                            cname: '\u5362\u68ee\u5821',
                            name: 'Luxembourg',
                            code: 'LU'
                        },
                        {
                            cname: '\u5723\u9a6c\u529b\u8bfa',
                            name: 'San Marino',
                            code: 'SM'
                        },
                        {
                            cname: '\u585e\u5c14\u7ef4\u4e9a',
                            name: 'Serbia',
                            code: 'RS'
                        },
                        {
                            cname: '\u5965\u5170\u7fa4\u5c9b',
                            name: 'Aland Island',
                            code: 'AX'
                        },
                        {
                            cname: '\u5965\u5730\u5229',
                            name: 'Austria',
                            code: 'AT'
                        },
                        {
                            cname: '\u5b89\u9053\u5c14',
                            name: 'Andorra',
                            code: 'AD'
                        },
                        { cname: '\u5e0c\u814a', name: 'Greece', code: 'GR' },
                        { cname: '\u5fb7\u56fd', name: 'Germany', code: 'DE' },
                        {
                            cname: '\u610f\u5927\u5229',
                            name: 'Italy',
                            code: 'IT'
                        },
                        {
                            cname: '\u62c9\u8131\u7ef4\u4e9a',
                            name: 'Latvia',
                            code: 'LV'
                        },
                        { cname: '\u632a\u5a01', name: 'Norway', code: 'NO' },
                        {
                            cname: '\u6377\u514b',
                            name: 'Czech Republic',
                            code: 'CZ'
                        },
                        {
                            cname: '\u6469\u5c14\u591a\u74e6',
                            name: 'Moldova',
                            code: 'MD'
                        },
                        {
                            cname: '\u6469\u7eb3\u54e5',
                            name: 'Monaco',
                            code: 'MC'
                        },
                        {
                            cname: '\u65af\u6d1b\u4f10\u514b',
                            name: 'Slovakia',
                            code: 'SK'
                        },
                        {
                            cname: '\u65af\u6d1b\u6587\u5c3c\u4e9a',
                            name: 'Slovenia',
                            code: 'SI'
                        },
                        {
                            cname: '\u6839\u897f\u5c9b',
                            name: 'Guernsey',
                            code: 'GG'
                        },
                        {
                            cname: '\u68b5\u8482\u5188',
                            name: 'Vatican City (The Holy See)',
                            code: 'VA'
                        },
                        {
                            cname: '\u6bd4\u5229\u65f6',
                            name: 'Belgium',
                            code: 'BE'
                        },
                        { cname: '\u6cd5\u56fd', name: 'France', code: 'FR' },
                        {
                            cname: '\u6cd5\u7f57\u7fa4\u5c9b',
                            name: 'Faroe Islands',
                            code: 'FO'
                        },
                        { cname: '\u6ce2\u5170', name: 'Poland', code: 'PL' },
                        {
                            cname: '\u6ce2\u9ed1',
                            name: 'Bosnia & Herzegovina',
                            code: 'BA'
                        },
                        {
                            cname: '\u6cfd\u897f\u5c9b',
                            name: 'Jersey',
                            code: 'JE'
                        },
                        {
                            cname: '\u7231\u5c14\u5170',
                            name: 'Ireland',
                            code: 'IE'
                        },
                        {
                            cname: '\u7231\u6c99\u5c3c\u4e9a',
                            name: 'Estonia',
                            code: 'EE'
                        },
                        { cname: '\u745e\u5178', name: 'Sweden', code: 'SE' },
                        {
                            cname: '\u745e\u58eb',
                            name: 'Switzerland',
                            code: 'CH'
                        },
                        {
                            cname: '\u767d\u4fc4\u7f57\u65af',
                            name: 'Belarus',
                            code: 'BY'
                        },
                        {
                            cname: '\u76f4\u5e03\u7f57\u9640',
                            name: 'Gibraltar',
                            code: 'GI'
                        },
                        {
                            cname: '\u7acb\u9676\u5b9b',
                            name: 'Lithuania',
                            code: 'LT'
                        },
                        {
                            cname: '\u7f57\u9a6c\u5c3c\u4e9a',
                            name: 'Romania',
                            code: 'RO'
                        },
                        { cname: '\u82ac\u5170', name: 'Finland', code: 'FI' },
                        {
                            cname: '\u82f1\u56fd',
                            name: 'Great Britain (United Kingdom / England)',
                            code: 'GB'
                        },
                        {
                            cname: '\u8377\u5170',
                            name: 'Netherlands',
                            code: 'NL'
                        },
                        {
                            cname: '\u8461\u8404\u7259',
                            name: 'Portugal',
                            code: 'PT'
                        },
                        {
                            cname: '\u897f\u73ed\u7259',
                            name: 'Spain',
                            code: 'ES'
                        },
                        {
                            cname: '\u963f\u5c14\u5df4\u5c3c\u4e9a',
                            name: 'Albania',
                            code: 'AL'
                        },
                        {
                            cname: '\u9a6c\u5176\u987f',
                            name: 'Republic of Macedonia (FYROM)',
                            code: 'MK'
                        },
                        {
                            cname: '\u9a6c\u6069\u5c9b',
                            name: 'Isle of Man',
                            code: 'IM'
                        },
                        {
                            cname: '\u9a6c\u8033\u4ed6',
                            name: 'Malta',
                            code: 'MT'
                        },
                        {
                            cname: '\u9ed1\u5c71',
                            name: 'Montenegro',
                            code: 'ME'
                        }
                    ]
                },
                {
                    name: 'NA',
                    cname: '\u5317\u7f8e\u6d32',
                    country: [
                        {
                            cname: '\u8377\u5170\u52a0\u52d2\u6bd4\u533a',
                            name: 'Caribbean Netherlands',
                            code: 'BQ'
                        },
                        {
                            cname: '\u8499\u585e\u62c9\u7279\u5c9b',
                            name: 'Montserrat',
                            code: 'MS'
                        },
                        {
                            cname: '\u4f2f\u5229\u5179',
                            name: 'Belize',
                            code: 'BZ'
                        },
                        {
                            cname: '\u52a0\u62ff\u5927',
                            name: 'Canada',
                            code: 'CA'
                        },
                        {
                            cname: '\u5371\u5730\u9a6c\u62c9',
                            name: 'Guatemala',
                            code: 'GT'
                        },
                        { cname: '\u53e4\u5df4', name: 'Cuba', code: 'CU' },
                        {
                            cname: '\u54e5\u65af\u8fbe\u9ece\u52a0',
                            name: 'Costa Rica',
                            code: 'CR'
                        },
                        {
                            cname: '\u5723\u5362\u897f\u4e9a',
                            name: 'St. Lucia',
                            code: 'LC'
                        },
                        {
                            cname: '\u5723\u57fa\u8328\u548c\u5c3c\u7ef4\u65af',
                            name: 'St. Kitts & Nevis',
                            code: 'KN'
                        },
                        {
                            cname: '\u5723\u5df4\u6cf0\u52d2\u7c73\u5c9b',
                            name: 'Saint Barth\u00e9lemy',
                            code: 'BL'
                        },
                        {
                            cname: '\u5723\u6587\u68ee\u7279\u548c\u683c\u6797\u7eb3\u4e01\u65af',
                            name: 'St. Vincent & the Grenadines',
                            code: 'VC'
                        },
                        {
                            cname: '\u5723\u76ae\u57c3\u5c14\u548c\u5bc6\u514b\u9686',
                            name: 'Saint-Pierre & Miquelon',
                            code: 'PM'
                        },
                        {
                            cname: '\u58a8\u897f\u54e5',
                            name: 'Mexico',
                            code: 'MX'
                        },
                        {
                            cname: '\u591a\u7c73\u5c3c\u514b',
                            name: 'Dominica',
                            code: 'DM'
                        },
                        {
                            cname: '\u591a\u7c73\u5c3c\u52a0',
                            name: 'Dominican Republic',
                            code: 'DO'
                        },
                        {
                            cname: '\u5b89\u572d\u62c9',
                            name: 'Anguilla',
                            code: 'AI'
                        },
                        {
                            cname: '\u5b89\u63d0\u74dc\u548c\u5df4\u5e03\u8fbe',
                            name: 'Antigua & Barbuda',
                            code: 'AG'
                        },
                        {
                            cname: '\u5c3c\u52a0\u62c9\u74dc',
                            name: 'Nicaragua',
                            code: 'NI'
                        },
                        {
                            cname: '\u5df4\u54c8\u9a6c',
                            name: 'The Bahamas',
                            code: 'BS'
                        },
                        {
                            cname: '\u5df4\u5df4\u591a\u65af',
                            name: 'Barbados',
                            code: 'BB'
                        },
                        {
                            cname: '\u5df4\u62ff\u9a6c',
                            name: 'Panama',
                            code: 'PA'
                        },
                        {
                            cname: '\u5e93\u62c9\u7d22',
                            name: 'Curacao',
                            code: 'CW'
                        },
                        {
                            cname: '\u5f00\u66fc\u7fa4\u5c9b',
                            name: 'Cayman Islands',
                            code: 'KY'
                        },
                        {
                            cname: '\u683c\u6797\u7eb3\u8fbe',
                            name: 'Grenada',
                            code: 'GD'
                        },
                        {
                            cname: '\u683c\u9675\u5170',
                            name: 'Greenland',
                            code: 'GL'
                        },
                        {
                            cname: '\u6cd5\u5c5e\u5723\u9a6c\u4e01',
                            name: 'Saint Martin (France)',
                            code: 'MF'
                        },
                        {
                            cname: '\u6ce2\u591a\u9ece\u5404',
                            name: 'Puerto Rico',
                            code: 'PR'
                        },
                        {
                            cname: '\u6d2a\u90fd\u62c9\u65af',
                            name: 'Honduras',
                            code: 'HN'
                        },
                        { cname: '\u6d77\u5730', name: 'Haiti', code: 'HT' },
                        {
                            cname: '\u7259\u4e70\u52a0',
                            name: 'Jamaica',
                            code: 'JM'
                        },
                        {
                            cname: '\u7279\u514b\u65af\u548c\u51ef\u79d1\u65af\u7fa4\u5c9b',
                            name: 'Turks & Caicos Islands',
                            code: 'TC'
                        },
                        {
                            cname: '\u7279\u7acb\u5c3c\u8fbe\u548c\u591a\u5df4\u54e5',
                            name: 'Trinidad & Tobago',
                            code: 'TT'
                        },
                        {
                            cname: '\u74dc\u5fb7\u7f57\u666e',
                            name: 'Guadeloupe',
                            code: 'GP'
                        },
                        {
                            cname: '\u767e\u6155\u5927',
                            name: 'Bermuda',
                            code: 'BM'
                        },
                        {
                            cname: '\u7f8e\u56fd',
                            name: 'United States of America (USA)',
                            code: 'US'
                        },
                        {
                            cname: '\u7f8e\u56fd\u672c\u571f\u5916\u5c0f\u5c9b\u5c7f',
                            name: 'United States Minor Outlying Islands',
                            code: 'UM'
                        },
                        {
                            cname: '\u7f8e\u5c5e\u7ef4\u5c14\u4eac\u7fa4\u5c9b',
                            name: 'United States Virgin Islands',
                            code: 'VI'
                        },
                        {
                            cname: '\u82f1\u5c5e\u7ef4\u5c14\u4eac\u7fa4\u5c9b',
                            name: 'British Virgin Islands',
                            code: 'VG'
                        },
                        {
                            cname: '\u8377\u5c5e\u5723\u9a6c\u4e01',
                            name: 'Sint Maarten',
                            code: 'SX'
                        },
                        {
                            cname: '\u8428\u5c14\u74e6\u591a',
                            name: 'El Salvador',
                            code: 'SV'
                        },
                        {
                            cname: '\u963f\u9c81\u5df4',
                            name: 'Aruba',
                            code: 'AW'
                        },
                        {
                            cname: '\u9a6c\u63d0\u5c3c\u514b',
                            name: 'Martinique',
                            code: 'MQ'
                        }
                    ]
                },
                {
                    name: 'AF',
                    cname: '\u975e\u6d32',
                    country: [
                        {
                            cname: '\u897f\u6492\u54c8\u62c9',
                            name: 'Western Sahara',
                            code: 'EH'
                        },
                        {
                            cname: '\u4e2d\u975e',
                            name: 'Central African Republic',
                            code: 'CF'
                        },
                        {
                            cname: '\u4e4c\u5e72\u8fbe',
                            name: 'Uganda',
                            code: 'UG'
                        },
                        { cname: '\u4e4d\u5f97', name: 'Chad', code: 'TD' },
                        {
                            cname: '\u4f5b\u5f97\u89d2',
                            name: 'Cape Verde',
                            code: 'CV'
                        },
                        {
                            cname: '\u5188\u6bd4\u4e9a',
                            name: 'Gambia',
                            code: 'GM'
                        },
                        {
                            cname: '\u51e0\u5185\u4e9a',
                            name: 'Guinea',
                            code: 'GN'
                        },
                        {
                            cname: '\u51e0\u5185\u4e9a\u6bd4\u7ecd',
                            name: 'Guinea-Bissau',
                            code: 'GW'
                        },
                        {
                            cname: '\u521a\u679c(\u5e03)',
                            name: 'Republic of the Congo',
                            code: 'CG'
                        },
                        {
                            cname: '\u521a\u679c(\u91d1)',
                            name: 'Democratic Republic of the Congo',
                            code: 'CD'
                        },
                        {
                            cname: '\u5229\u6bd4\u4e9a',
                            name: 'Libya',
                            code: 'LY'
                        },
                        {
                            cname: '\u5229\u6bd4\u91cc\u4e9a',
                            name: 'Liberia',
                            code: 'LR'
                        },
                        { cname: '\u52a0\u7eb3', name: 'Ghana', code: 'GH' },
                        { cname: '\u52a0\u84ec', name: 'Gabon', code: 'GA' },
                        {
                            cname: '\u5357\u82cf\u4e39',
                            name: 'South Sudan',
                            code: 'SS'
                        },
                        {
                            cname: '\u5357\u975e',
                            name: 'South Africa',
                            code: 'ZA'
                        },
                        {
                            cname: '\u535a\u8328\u74e6\u7eb3',
                            name: 'Botswana',
                            code: 'BW'
                        },
                        {
                            cname: '\u5362\u65fa\u8fbe',
                            name: 'Rwanda',
                            code: 'RW'
                        },
                        {
                            cname: '\u5384\u7acb\u7279\u91cc\u4e9a',
                            name: 'Eritrea',
                            code: 'ER'
                        },
                        {
                            cname: '\u5409\u5e03\u63d0',
                            name: 'Djibouti',
                            code: 'DJ'
                        },
                        {
                            cname: '\u5580\u9ea6\u9686',
                            name: 'Cameroon',
                            code: 'CM'
                        },
                        {
                            cname: '\u5723\u591a\u7f8e\u548c\u666e\u6797\u897f\u6bd4',
                            name: 'Sao Tome & Principe',
                            code: 'ST'
                        },
                        {
                            cname: '\u5723\u8d6b\u52d2\u62ff',
                            name: 'St. Helena & Dependencies',
                            code: 'SH'
                        },
                        {
                            cname: '\u5766\u6851\u5c3c\u4e9a',
                            name: 'Tanzania',
                            code: 'TZ'
                        },
                        { cname: '\u57c3\u53ca', name: 'Egypt', code: 'EG' },
                        {
                            cname: '\u57c3\u585e\u4fc4\u6bd4\u4e9a',
                            name: 'Ethiopia',
                            code: 'ET'
                        },
                        {
                            cname: '\u585e\u5185\u52a0\u5c14',
                            name: 'Senegal',
                            code: 'SN'
                        },
                        {
                            cname: '\u585e\u62c9\u5229\u6602',
                            name: 'Sierra Leone',
                            code: 'SL'
                        },
                        {
                            cname: '\u585e\u820c\u5c14',
                            name: 'Seychelles',
                            code: 'SC'
                        },
                        { cname: '\u591a\u54e5', name: 'Togo', code: 'TG' },
                        {
                            cname: '\u5b89\u54e5\u62c9',
                            name: 'Angola',
                            code: 'AO'
                        },
                        {
                            cname: '\u5c3c\u65e5\u5229\u4e9a',
                            name: 'Nigeria',
                            code: 'NG'
                        },
                        {
                            cname: '\u5c3c\u65e5\u5c14',
                            name: 'Niger',
                            code: 'NE'
                        },
                        {
                            cname: '\u5e03\u57fa\u7eb3\u6cd5\u7d22',
                            name: 'Burkina',
                            code: 'BF'
                        },
                        {
                            cname: '\u5e03\u9686\u8fea',
                            name: 'Burundi',
                            code: 'BI'
                        },
                        {
                            cname: '\u6469\u6d1b\u54e5',
                            name: 'Morocco',
                            code: 'MA'
                        },
                        {
                            cname: '\u65af\u5a01\u58eb\u5170',
                            name: 'Swaziland',
                            code: 'SZ'
                        },
                        {
                            cname: '\u6bdb\u91cc\u5854\u5c3c\u4e9a',
                            name: 'Mauritania',
                            code: 'MR'
                        },
                        {
                            cname: '\u6bdb\u91cc\u6c42\u65af',
                            name: 'Mauritius',
                            code: 'MU'
                        },
                        {
                            cname: '\u6d25\u5df4\u5e03\u97e6',
                            name: 'Zimbabwe',
                            code: 'ZW'
                        },
                        {
                            cname: '\u7559\u5c3c\u6c6a',
                            name: 'R\u00e9union',
                            code: 'RE'
                        },
                        {
                            cname: '\u79d1\u6469\u7f57',
                            name: 'The Comoros',
                            code: 'KM'
                        },
                        {
                            cname: '\u79d1\u7279\u8fea\u74e6',
                            name: "Cote d'Ivoire",
                            code: 'CI'
                        },
                        {
                            cname: '\u7a81\u5c3c\u65af',
                            name: 'Tunisia',
                            code: 'TN'
                        },
                        {
                            cname: '\u7d22\u9a6c\u91cc',
                            name: 'Somalia',
                            code: 'SO'
                        },
                        {
                            cname: '\u7eb3\u7c73\u6bd4\u4e9a',
                            name: 'Namibia',
                            code: 'NA'
                        },
                        {
                            cname: '\u80af\u5c3c\u4e9a',
                            name: 'Kenya',
                            code: 'KE'
                        },
                        { cname: '\u82cf\u4e39', name: 'Sudan', code: 'SD' },
                        {
                            cname: '\u82f1\u5c5e\u5370\u5ea6\u6d0b\u9886\u5730',
                            name: 'British Indian Ocean Territory',
                            code: 'IO'
                        },
                        {
                            cname: '\u83ab\u6851\u6bd4\u514b',
                            name: 'Mozambique',
                            code: 'MZ'
                        },
                        {
                            cname: '\u83b1\u7d22\u6258',
                            name: 'Lesotho',
                            code: 'LS'
                        },
                        { cname: '\u8d1d\u5b81', name: 'Benin', code: 'BJ' },
                        {
                            cname: '\u8d5e\u6bd4\u4e9a',
                            name: 'Zambia',
                            code: 'ZM'
                        },
                        {
                            cname: '\u8d64\u9053\u51e0\u5185\u4e9a',
                            name: 'Equatorial Guinea',
                            code: 'GQ'
                        },
                        {
                            cname: '\u963f\u5c14\u53ca\u5229\u4e9a',
                            name: 'Algeria',
                            code: 'DZ'
                        },
                        {
                            cname: '\u9a6c\u62c9\u7ef4',
                            name: 'Malawi',
                            code: 'MW'
                        },
                        {
                            cname: '\u9a6c\u7ea6\u7279',
                            name: 'Mayotte',
                            code: 'YT'
                        },
                        {
                            cname: '\u9a6c\u8fbe\u52a0\u65af\u52a0',
                            name: 'Madagascar',
                            code: 'MG'
                        },
                        { cname: '\u9a6c\u91cc', name: 'Mali', code: 'ML' }
                    ]
                },
                {
                    name: 'AS',
                    cname: '\u4e9a\u6d32',
                    country: [
                        { cname: '\u4e0d\u4e39', name: 'Bhutan', code: 'BT' },
                        {
                            cname: '\u4e1c\u5e1d\u6c76',
                            name: 'Timor-Leste (East Timor)',
                            code: 'TL'
                        },
                        { cname: '\u4e2d\u56fd', name: 'China', code: 'CN' },
                        {
                            cname: '\u4e4c\u5179\u522b\u514b\u65af\u5766',
                            name: 'Uzbekistan',
                            code: 'UZ'
                        },
                        { cname: '\u4e5f\u95e8', name: 'Yemen', code: 'YE' },
                        {
                            cname: '\u4e9a\u7f8e\u5c3c\u4e9a',
                            name: 'Armenia',
                            code: 'AM'
                        },
                        {
                            cname: '\u4ee5\u8272\u5217',
                            name: 'Israel',
                            code: 'IL'
                        },
                        {
                            cname: '\u4f0a\u62c9\u514b',
                            name: 'Iraq',
                            code: 'IQ'
                        },
                        { cname: '\u4f0a\u6717', name: 'Iran', code: 'IR' },
                        {
                            cname: '\u5361\u5854\u5c14',
                            name: 'Qatar',
                            code: 'QA'
                        },
                        {
                            cname: '\u5370\u5c3c',
                            name: 'Indonesia',
                            code: 'ID'
                        },
                        { cname: '\u5370\u5ea6', name: 'India', code: 'IN' },
                        {
                            cname: '\u53d9\u5229\u4e9a',
                            name: 'Syria',
                            code: 'SY'
                        },
                        { cname: '\u53f0\u6e7e', name: 'Taiwan', code: 'TW' },
                        {
                            cname: '\u5409\u5c14\u5409\u65af\u65af\u5766',
                            name: 'Kyrgyzstan',
                            code: 'KG'
                        },
                        {
                            cname: '\u54c8\u8428\u514b\u65af\u5766',
                            name: 'Kazakhstan',
                            code: 'KZ'
                        },
                        {
                            cname: '\u571f\u5e93\u66fc\u65af\u5766',
                            name: 'Turkmenistan',
                            code: 'TM'
                        },
                        {
                            cname: '\u571f\u8033\u5176',
                            name: 'Turkey',
                            code: 'TR'
                        },
                        {
                            cname: '\u5723\u8bde\u5c9b',
                            name: 'Christmas Island',
                            code: 'CX'
                        },
                        {
                            cname: '\u5854\u5409\u514b\u65af\u5766',
                            name: 'Tajikistan',
                            code: 'TJ'
                        },
                        {
                            cname: '\u585e\u6d66\u8def\u65af',
                            name: 'Cyprus',
                            code: 'CY'
                        },
                        {
                            cname: '\u5b5f\u52a0\u62c9',
                            name: 'Bangladesh',
                            code: 'BD'
                        },
                        {
                            cname: '\u5c3c\u6cca\u5c14',
                            name: 'Nepal',
                            code: 'NP'
                        },
                        {
                            cname: '\u5df4\u52d2\u65af\u5766',
                            name: 'Palestinian territories',
                            code: 'PS'
                        },
                        {
                            cname: '\u5df4\u57fa\u65af\u5766',
                            name: 'Pakistan',
                            code: 'PK'
                        },
                        { cname: '\u5df4\u6797', name: 'Bahrain', code: 'BH' },
                        { cname: '\u6587\u83b1', name: 'Brunei', code: 'BN' },
                        {
                            cname: '\u65af\u91cc\u5170\u5361',
                            name: 'Sri Lanka',
                            code: 'LK'
                        },
                        {
                            cname: '\u65b0\u52a0\u5761',
                            name: 'Singapore',
                            code: 'SG'
                        },
                        { cname: '\u65e5\u672c', name: 'Japan', code: 'JP' },
                        {
                            cname: '\u671d\u9c9c',
                            name: 'North Korea',
                            code: 'KP'
                        },
                        {
                            cname: '\u67ec\u57d4\u5be8',
                            name: 'Cambodia',
                            code: 'KH'
                        },
                        {
                            cname: '\u683c\u9c81\u5409\u4e9a',
                            name: 'Georgia',
                            code: 'GE'
                        },
                        {
                            cname: '\u6c99\u7279\u963f\u62c9\u4f2f',
                            name: 'Saudi Arabia',
                            code: 'SA'
                        },
                        { cname: '\u6cf0\u56fd', name: 'Thailand', code: 'TH' },
                        { cname: '\u6fb3\u95e8', name: 'Macao', code: 'MO' },
                        {
                            cname: '\u79d1\u5a01\u7279',
                            name: 'Kuwait',
                            code: 'KW'
                        },
                        {
                            cname: '\u79d1\u79d1\u65af\u7fa4\u5c9b',
                            name: 'Cocos (Keeling) Islands',
                            code: 'CC'
                        },
                        { cname: '\u7ea6\u65e6', name: 'Jordan', code: 'JO' },
                        {
                            cname: '\u7f05\u7538',
                            name: 'Myanmar (Burma)',
                            code: 'MM'
                        },
                        { cname: '\u8001\u631d', name: 'Laos', code: 'LA' },
                        {
                            cname: '\u83f2\u5f8b\u5bbe',
                            name: 'The Philippines',
                            code: 'PH'
                        },
                        {
                            cname: '\u8499\u53e4\u56fd',
                            name: 'Mongolia',
                            code: 'MN'
                        },
                        { cname: '\u8d8a\u5357', name: 'Vietnam', code: 'VN' },
                        {
                            cname: '\u963f\u585e\u62dc\u7586',
                            name: 'Azerbaijan',
                            code: 'AZ'
                        },
                        {
                            cname: '\u963f\u5bcc\u6c57',
                            name: 'Afghanistan',
                            code: 'AF'
                        },
                        { cname: '\u963f\u66fc', name: 'Oman', code: 'OM' },
                        {
                            cname: '\u963f\u6839\u5ef7',
                            name: 'Argentina',
                            code: 'AR'
                        },
                        {
                            cname: '\u963f\u8054\u914b',
                            name: 'United Arab Emirates',
                            code: 'AE'
                        },
                        {
                            cname: '\u97e9\u56fd',
                            name: 'South Korea',
                            code: 'KR'
                        },
                        {
                            cname: '\u9999\u6e2f',
                            name: 'Hong Kong',
                            code: 'HK'
                        },
                        {
                            cname: '\u9a6c\u5c14\u4ee3\u592b',
                            name: 'Maldives',
                            code: 'MV'
                        },
                        {
                            cname: '\u9a6c\u6765\u897f\u4e9a',
                            name: 'Malaysia',
                            code: 'MY'
                        },
                        {
                            cname: '\u9ece\u5df4\u5ae9',
                            name: 'Lebanon',
                            code: 'LB'
                        }
                    ]
                },
                {
                    name: 'AN',
                    cname: '\u5357\u6781\u6d32',
                    country: [
                        {
                            cname: '\u5357\u4e54\u6cbb\u4e9a\u5c9b\u548c\u5357\u6851\u5a01\u5947\u7fa4\u5c9b',
                            name: 'South Georgia & the South Sandwich Islands',
                            code: 'GS'
                        },
                        {
                            cname: '\u5357\u6781\u6d32',
                            name: 'Antarctica',
                            code: 'AQ'
                        },
                        {
                            cname: '\u5e03\u97e6\u5c9b',
                            name: 'Bouvet Island',
                            code: 'BV'
                        },
                        {
                            cname: '\u6cd5\u5c5e\u5357\u90e8\u9886\u5730',
                            name: 'French Southern Territories',
                            code: 'TF'
                        },
                        {
                            cname: '\u8d6b\u5fb7\u5c9b\u548c\u9ea6\u514b\u5510\u7eb3\u7fa4\u5c9b',
                            name: 'Heard Island & McDonald Islands',
                            code: 'HM'
                        }
                    ]
                },
                {
                    name: 'SA',
                    cname: '\u5357\u7f8e\u6d32',
                    country: [
                        {
                            cname: '\u4e4c\u62c9\u572d',
                            name: 'Uruguay',
                            code: 'UY'
                        },
                        {
                            cname: '\u5384\u74dc\u591a\u5c14',
                            name: 'Ecuador',
                            code: 'EC'
                        },
                        {
                            cname: '\u54e5\u4f26\u6bd4\u4e9a',
                            name: 'Colombia',
                            code: 'CO'
                        },
                        {
                            cname: '\u572d\u4e9a\u90a3',
                            name: 'Guyana',
                            code: 'GY'
                        },
                        {
                            cname: '\u59d4\u5185\u745e\u62c9',
                            name: 'Venezuela',
                            code: 'VE'
                        },
                        {
                            cname: '\u5df4\u62c9\u572d',
                            name: 'Paraguay',
                            code: 'PY'
                        },
                        { cname: '\u5df4\u897f', name: 'Brazil', code: 'BR' },
                        { cname: '\u667a\u5229', name: 'Chile', code: 'CL' },
                        {
                            cname: '\u6cd5\u5c5e\u572d\u4e9a\u90a3',
                            name: 'French Guiana',
                            code: 'GF'
                        },
                        {
                            cname: '\u73bb\u5229\u7ef4\u4e9a',
                            name: 'Bolivia',
                            code: 'BO'
                        },
                        { cname: '\u79d8\u9c81', name: 'Peru', code: 'PE' },
                        {
                            cname: '\u82cf\u91cc\u5357',
                            name: 'Suriname',
                            code: 'SR'
                        },
                        {
                            cname: '\u9a6c\u5c14\u7ef4\u7eb3\u65af\u7fa4\u5c9b(\u798f\u514b\u5170)',
                            name: 'Falkland Islands',
                            code: 'FK'
                        }
                    ]
                },
                {
                    name: 'OA',
                    cname: '\u5927\u6d0b\u6d32',
                    country: [
                        { cname: '\u5173\u5c9b', name: 'Guam', code: 'GU' },
                        {
                            cname: '\u5317\u9a6c\u91cc\u4e9a\u7eb3\u7fa4\u5c9b',
                            name: 'Northern Mariana Islands',
                            code: 'MP'
                        },
                        {
                            cname: '\u56fe\u74e6\u5362',
                            name: 'Tuvalu',
                            code: 'TV'
                        },
                        {
                            cname: '\u57fa\u91cc\u5df4\u65af',
                            name: 'Kiribati',
                            code: 'KI'
                        },
                        {
                            cname: '\u5bc6\u514b\u7f57\u5c3c\u897f\u4e9a\u8054\u90a6',
                            name: 'Federated States of Micronesia',
                            code: 'FM'
                        },
                        {
                            cname: '\u5df4\u5e03\u4e9a\u65b0\u51e0\u5185\u4e9a',
                            name: 'Papua New Guinea',
                            code: 'PG'
                        },
                        { cname: '\u5e15\u52b3', name: 'Palau', code: 'PW' },
                        {
                            cname: '\u5e93\u514b\u7fa4\u5c9b',
                            name: 'Cook Islands',
                            code: 'CK'
                        },
                        {
                            cname: '\u6240\u7f57\u95e8\u7fa4\u5c9b',
                            name: 'Solomon Islands',
                            code: 'SB'
                        },
                        {
                            cname: '\u6258\u514b\u52b3',
                            name: 'Tokelau',
                            code: 'TK'
                        },
                        {
                            cname: '\u6590\u6d4e\u7fa4\u5c9b',
                            name: 'Fiji',
                            code: 'FJ'
                        },
                        {
                            cname: '\u65b0\u5580\u91cc\u591a\u5c3c\u4e9a',
                            name: 'New Caledonia',
                            code: 'NC'
                        },
                        {
                            cname: '\u65b0\u897f\u5170',
                            name: 'New Zealand',
                            code: 'NZ'
                        },
                        { cname: '\u6c64\u52a0', name: 'Tonga', code: 'TO' },
                        {
                            cname: '\u6cd5\u5c5e\u6ce2\u5229\u5c3c\u897f\u4e9a',
                            name: 'French polynesia',
                            code: 'PF'
                        },
                        {
                            cname: '\u6fb3\u5927\u5229\u4e9a',
                            name: 'Australia',
                            code: 'AU'
                        },
                        { cname: '\u7459\u9c81', name: 'Nauru', code: 'NR' },
                        {
                            cname: '\u74e6\u5229\u65af\u548c\u5bcc\u56fe\u7eb3',
                            name: 'Wallis & Futuna',
                            code: 'WF'
                        },
                        {
                            cname: '\u74e6\u52aa\u963f\u56fe',
                            name: 'Vanuatu',
                            code: 'VU'
                        },
                        {
                            cname: '\u76ae\u7279\u51ef\u6069\u7fa4\u5c9b',
                            name: 'Pitcairn Islands',
                            code: 'PN'
                        },
                        { cname: '\u7ebd\u57c3', name: 'Niue', code: 'NU' },
                        {
                            cname: '\u7f8e\u5c5e\u8428\u6469\u4e9a',
                            name: 'American Samoa',
                            code: 'AS'
                        },
                        {
                            cname: '\u8428\u6469\u4e9a',
                            name: 'Samoa',
                            code: 'WS'
                        },
                        {
                            cname: '\u8bfa\u798f\u514b\u5c9b',
                            name: 'Norfolk Island',
                            code: 'NF'
                        },
                        {
                            cname: '\u9a6c\u7ecd\u5c14\u7fa4\u5c9b',
                            name: 'Marshall islands',
                            code: 'MH'
                        }
                    ]
                }
            ]
		}
	},
	mounted() {
		const init = this.modelValue ?? this.initCode
		if (init != null && init !== '') {
			this.applyInit(init)
		}
	},
	watch: {
		initCode(v) {
			if (v != null && v !== '') this.applyInit(v)
		},
		modelValue(v) {
			if (v == null || v === '') {
				if (this.selected.length) this.selected = []
				return
			}
			const next = this.normalizeCodes(v)
			const same =
				next.length === this.selected.length && next.every((c, i) => c === this.selected[i])
			if (!same) this.applyInit(v)
		},
		multiple(val) {
			if (!val && this.selected.length > 1) {
				this.selected = [this.selected[0]]
				this.emitSelection()
			}
		}
	},
	computed: {
		countryIndex() {
			const map = {}
			for (const continent of this.continents) {
				for (const c of continent.country || []) {
					map[c.code] = { ...c, continent: continent.name }
				}
			}
			return map
		},
		commonCodeSet() {
			return new Set((this.commonCodes || []).map((c) => String(c).toUpperCase()))
		},
		/** 弹窗列表：常用 + 额外加入的非常用 */
		listCountries() {
			const codes = []
			const seen = new Set()
			for (const code of [...(this.commonCodes || []), ...this.extraCodes]) {
				const c = String(code).toUpperCase()
				if (seen.has(c)) continue
				const info = this.countryIndex[c]
				if (!info) continue
				seen.add(c)
				codes.push(info)
			}
			return codes
		},
		selectedList() {
			return this.selected
		},
		/** 下拉中排除已在列表里的国家 */
		dropdownCountries() {
			const inList = new Set(this.listCountries.map((c) => c.code))
			return (this.countries || []).filter((c) => !inList.has(c.code))
		}
	},
	methods: {
		normalizeCodes(init) {
			const arr = Array.isArray(init) ? init : String(init).split(/[,，\s]+/)
			return arr.filter(Boolean).map((c) => String(c).toUpperCase())
		},
		countryLabel(code) {
			return this.countryIndex[code]?.cname || code
		},
		isSelected(code) {
			return this.selected.includes(String(code).toUpperCase())
		},
		applyInit(init) {
			const codes = this.normalizeCodes(init).filter((c) => this.countryIndex[c])
			this.selected = this.multiple ? codes : codes.slice(0, 1)
			// 已选但不在常用里的，加入额外列表
			for (const code of this.selected) {
				if (!this.commonCodeSet.has(code) && !this.extraCodes.includes(code)) {
					this.extraCodes.push(code)
				}
			}
		},
		openDialog() {
			this.continent = null
			this.pickCountry = null
			this.countries = []
			this.dialog = true
		},
		confirmDialog() {
			this.emitSelection()
			this.dialog = false
		},
		clearSelection() {
			this.selected = []
			this.emitSelection()
		},
		toggleCode(code) {
			code = String(code).toUpperCase()
			if (!this.countryIndex[code]) return
			if (this.multiple) {
				const idx = this.selected.indexOf(code)
				if (idx >= 0) this.selected.splice(idx, 1)
				else this.selected.push(code)
			} else {
				this.selected = this.isSelected(code) ? [] : [code]
			}
			this.emitSelection()
		},
		removeCode(code) {
			code = String(code).toUpperCase()
			this.selected = this.selected.filter((c) => c !== code)
			this.emitSelection()
		},
		onContinentChange() {
			this.pickCountry = null
			this.countries = []
			if (!this.continent) return
			const found = this.continents.find((c) => c.name === this.continent)
			this.countries = found?.country || []
		},
		addFromDropdown(code) {
			if (!code) return
			code = String(code).toUpperCase()
			if (!this.countryIndex[code]) return

			// 加入列表
			if (!this.commonCodeSet.has(code) && !this.extraCodes.includes(code)) {
				this.extraCodes.push(code)
			}
			// 自动选中
			if (this.multiple) {
				if (!this.selected.includes(code)) this.selected.push(code)
			} else {
				this.selected = [code]
			}
			this.pickCountry = null
			this.emitSelection()
		},
		emitSelection() {
			const value = this.multiple ? [...this.selected] : this.selected[0] || null
			this.$emit('update:modelValue', value)
			this.$emit('selected', value)
		}
	}
}
</script>

<style scoped>
.cursor-pointer {
	cursor: pointer;
}
.country-display {
	border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
	min-height: 40px;
	cursor: pointer;
	transition: border-color 0.15s ease;
}
.country-display:hover {
	border-color: rgb(var(--v-theme-primary));
}
.country-display--empty {
	background: rgba(var(--v-theme-on-surface), 0.02);
}
</style>
